











































































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountDepositFixedTermMaturitySettings from '@/models/Accounts/DepositAccounts/Settings/AccountDepositFixedTermMaturitySettings';
import AccountDepositFixedTermMaturitySettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/FixedTermMaturity/AccountDepositFixedTermMaturitySettingsEditDialog.vue';
import FixedTermMaturityType from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityType";
import FixedTermMaturityActionType from '@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityActionType';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountDepositFixedTermMaturitySettingsRead', components: { AccountDepositFixedTermMaturitySettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;
    FixedTermMaturityType = FixedTermMaturityType;
    FixedTermMaturityActionType = FixedTermMaturityActionType;

    @Prop({required: true })
    settings: AccountDepositFixedTermMaturitySettings;

    async deleteDepositFixedTermMaturitySettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountSettingsModule.deleteDepositFixedTermMaturitySettings();
        }
    }

}
